<template>
  <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 mt-10 maxw-1750">
    <!-- TITLE -->

    <!-- FILTERS -->
    <v-card>
      <v-row
        no-gutters
        align="center"
        class="px-4"
      >
        <v-col class="pt-3">
          <Searchbar
            ref="filterComponent"
            :placeholder="
              $t(`views.ticketListPend.placeholder`)
            "
            @search="submit"
          ></Searchbar>
        </v-col>

      </v-row>

      <v-row class="pt-2 pb-3 align-center" no-gutters>
        <!-- Chips estados -->
        <v-col>
          <div class="px-4 showWeb myRequestScroll container__chip">
            <v-chip
              v-show="firstLoadDone"
              v-for="filter in filtersInitialPending"
              :key="filter.status"
              :class="[filtersPending.includes(filter.status)
                ? 'chip__active'
                : '',
                'chip__agrupaciones chip__filter v-chip']"
              @click="filterSearch(filter)"
            >
              <v-badge
                :key="filter.status"
                class="d-inline"
                inline
                :color="filter.status ? colors(filter.status) : ''"
                dot
              ></v-badge>
              {{ textFilters(filter.status) }}
            </v-chip>
          </div>

          <FiltersSlide
            v-if="showFilters"
            :isBadge="isBadge"
            :filters="filtersInitialPending"
            :selectedFilters="filtersPending"
            @filter-selected="filterSearch"
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Loading skeletons -->
    <template class="mt-4" v-if="!firstLoadDone">
       <v-card
        v-for="i in 10"
        :key="`divider-${i}`"
        class="mx-0"
        tile
      >
        <v-skeleton-loader  :key="`loading-${i}`" type="list-item-three-line">
        </v-skeleton-loader>
      </v-card>
    </template>

    <v-col v-if="firstLoadDone && Number(this.total) === 0" cols="12">
      <span class="text-center text-h7">
        {{ $t("views.ticketList.empty") }}
      </span>
    </v-col>

    <div class="mt-2 hoverItem" v-if="firstLoadDone">
      <!-- TICKETS LIST DETAILS -->
      <ListItem
        v-for="(ticket, index) in tickets"
        :key="index"
        :showOpen="true"
        :url="`${goDetail}/${ticket.id}`"
        class="pt-2 pb-2"
      >
      <!-- :class="{ 'pt-2': true,}" -->
        <template v-slot:title>
          <div class="inlineFlexMW90">
            <div class="alignItemCenter titlePending">
          <!-- INICIAL TIPO DE SOLIICTUD  -->
          <v-avatar
            v-if="ticket.status != null"
            class="initialColor"
            :color="ticket.type.relAttr ? colors(ticket.status.code) : ''"
            size="32"
          >
            <v-icon
              class="initialColorIcon"
              v-color="colors(ticket.status.code)"
              v-text="textIcon(ticket)"
            ></v-icon>
          </v-avatar>
          <!-- ICONOS SEGUIDOR-INTERESADOS -->
          <i v-if="ticket.isSuscriptor"
            class="icon__interesado--request icon-ayudadigital-interesados-negativo"></i>
          <i v-else-if="ticket.isSeguidor"
            class="icon__seguidor--request icon-ayudadigital-ojo"></i>
          <i v-else class="iconNone"></i>

          <!-- TITLE -->
          <v-chip v-if="pathSelect()"
            class="ma-2"
            label small
            color="primary"
          >
            {{ ticket.referenceNumber }}
          </v-chip>

          <span
            v-if="$vuetify.breakpoint.mdAndUp"
            v-bind:class="['item-title', {
              'item-title-end': !$vuetify.breakpoint.smAndUp
            }]"
          >
            <i class="titlePending" v-if="!pathSelect()"> {{ ticket.referenceNumber }}</i> -
            {{ ticket.summary }}
          </span>

          <v-spacer />

          <span
            v-if="!$vuetify.breakpoint.mdAndUp"
            style="width: 100%"
            v-bind:class="['item-title', {
              'item-title-end': !$vuetify.breakpoint.smAndUp,
              'titlePending': true
            }]"
          >
            {{ ticket.summary }}
          </span>
            </div>
          </div>
        </template>

        <template v-slot:subtitle>
          <div v-if="ticket.description" v-html="ticket.description.replace(/\n/gi, '<br>')"></div>
          <v-spacer />
        </template>
      </ListItem>

      <InfiniteScroll
        :loading="loading"
        :size="10"
        v-if="firstLoadDone && total > 25 && (loading || pagesize < total)"
        :scroll="loading && firstLoadDone"
        margin="400px"
        root="html"
        class="mt-4"
        @scrollList="scrollTickets(10)"
      ></InfiniteScroll>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  ListItem, InfiniteScroll, Searchbar, FiltersSlide,
} from '@/components';
// @ is an alias to /src
export default {
  name: 'RequestPendingListView',
  components: {
    ListItem,
    InfiniteScroll,
    Searchbar,
    FiltersSlide,
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => ([]),
    },
    loading: Boolean,
    firstLoadDone: Boolean,
    goDetail: {
      type: String,
      default: () => '/requests',
    },
  },
  data() {
    return {
      start: 0,
      pagesize: 25,
      scroll: true,
      showFilters: false,
      filtersPending: [],
      filtersInitialPending: [],
      isBadge: true,
    };
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),

    formFiltersConfiguration() {
      // getting base configuration from constants
      return this.$getConst('listFilters.pend');
    },
    tickets() {
      let data = {};
      if (this.list) {
        data = this.list;
      }
      return data;
    },
    total() {
      let dataTotal = 0;
      if (this.list) {
        dataTotal = this.$attrs.total;
      }
      return dataTotal;
    },
  },

  methods: {
    pathSelect() {
      return !window.location.pathname.includes('pending');
    },
    filterSearch(data) {
      const { status } = data;
      if (this.filtersPending.includes(status)) {
        if (this.filtersPending.length === 1) {
          // TODO atLeastOneFilter
          console.log('components.searchBox.atLeastOneFilter');
          // this.$store.dispatch('messages/createNotificationMessage', {
          //   type: 'warning',
          //   icon: 'mdi-alert',
          //   title: this.$t('components.searchBox.atLeastOneFilter'),
          //   timeout: this.$getConst('notifications.timeout'),
          // });
          return;
        }
        this.filtersPending.splice(this.filtersPending.indexOf(status), 1);
      } else {
        this.filtersPending.push(status);
      }

      this.submit(this.filtersPending);
    },
    colors(status) {
      if (status) {
        const result = this.$getConst(`initialFilters.filterStatus.${status}.color`);
        return result;
      }
      return '';
    },
    textIcon(ticket) {
      if (ticket?.status?.code) {
        const result = this.$getConst(`initialFilters.filterStatus.${ticket.status.code}.initials`);
        return result;
      }
      return '';
    },
    textFilters(status) {
      if (status) {
        const result = this.$getConst(`initialFilters.filterStatus.${status}.text`);
        return result;
      }
      return '';
    },
    async search(action, start, size, filters) {
      const effectiveFilters = filters || this.filtersPending;
      await this.$emit('request', {
        type: 'pending',
        args: {
          start,
          size,
          filters: effectiveFilters,
          action,
        },
      });
    },
    async scrollTickets(increment) {
      if (this.pagesize <= this.total) {
        this.scroll = true;
        this.search('scroll', this.pagesize, increment, this.filtersPending);
        this.pagesize += increment;
      } else {
        this.scroll = false;
      }
    },
    styleObject(type) {
      switch (type) {
      case 'R':
        return '#99c2a5';
      case 'I':
        return '#cdcd9c';
      case 'P':
        return '#c55a11';
      default:
        return '#ff0000';
      }
    },
    submit() {
      const query = { status: this.filtersPending };
      this.start = 0;
      const searchInput = this.$refs.filterComponent.$children[0].value;

      if (searchInput) {
        query.search = searchInput;
      }

      this.search('list', 0, 25, query);
      this.pagesize = 25;
      this.$router.push({ name: this.$route.name, query }).catch(() => {});
    },
  },
  created() {
    this.search('list', 0, 25, this.filters);
  },
  async mounted() {
    this.filtersPending = this.filters.status;
    this.filtersInitialPending = this.$getConst('initialFilters.pending');

    setInterval(() => {
      this.showFilters = true;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
  .item-title-end {
    order: 4;
    //padding-left: 1.5rem;
    word-break: keep-all;
  }
  .initialColor{
    font-size: 0.5rem !important;
    //margin-right: 0.5rem;
  }
  .initialColorIcon{
    color: #ffffff !important;
    font-size: 14px !important;
  }
  .icon__interesado--request {
    font-size: 3rem
  }
  .icon__seguidor--request {
    font-size: 2.5rem
  }
  .iconNone {
    height: 32px;
    width: 32px;
    // height: 45px;
    // width: 45px;
  }
  .hoverItem :hover{
    background-color: #c8c8c8;
  }
  .chip__active {
    background-color: #e6f1ee !important;
    border: 1px solid #27846d !important;
  }
  .chip__filter {
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
    padding: 0 16px;
  }
  .showMobile {
    display: none !important;
  }

  .inlineFlexMW90{
      display: inline-flex;
      max-width: 90%;
  }
  .alignItemCenter{
    display: flex;
    align-items: center !important;
  }
  .titlePending{
    font-size: 0.95rem !important;
  }

  @media screen and (max-width: 600px) {
    .titlePending{
      font-size: 0.85rem !important;
    }
    .titleTicket{
      font-size: 0.85rem !important;
    }
    .showWeb {
      display: none !important;
    }
    .showMobile {
      display: flex !important;
    }
    .v-slide-group__next--disabled {
      display: none !important;
    }

    .v-slide-group__next {
      min-width: none !important;
    }
    .myRequestScroll{
    overflow: hidden;
    white-space: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
  }

}
</style>
